import { DataAnalytics, DataObject } from './common';
var cancelPaymentPageNames = {
    error: 'error',
    complete: 'complete',
    confirm: 'confirm',
    start: 'start'
};
export var getCancelPaymentAnalyticsEvent = function (event) { return ({
    pageFunction: 'cancel_payment',
    pageKind: 'activity',
    pageName: cancelPaymentPageNames[event]
}); };
var cancelPaymentDataTypes = {
    cancelPaymentCancel: 'cancel-payment',
    cancelPaymentClose: 'close',
    cancelPaymentErrorClose: 'close',
    cancelPaymentSuccessClose: 'close',
    reviewCancelPaymentYes: 'yes-cancel-payment',
    reviewCancelPaymentBack: 'back',
    xButton: 'x-button'
};
var getElementDataTypeValue = function (targetNameKey) { return cancelPaymentDataTypes[targetNameKey]; };
export var getCancelPaymentAnalyticsProps = function (targetName) { return ({
    'data-object': DataObject.button,
    'data-analytics': DataAnalytics.clickTrackingEvent,
    'data-type': getElementDataTypeValue(targetName)
}); };
//# sourceMappingURL=cancel-payment.js.map